module.exports = __webpack_public_path__ + "static/media/background_analysis.49b3c1cf.svg";